export default __webpack_public_path__ + "static/media/wh.6da1b0d6.png";